export enum AppRoutes {
    Main = "/",
}
